/**
 * @return {{feature: string}}
 */
export const incitationNewsletter = () => ({
  feature: 'incitation_newsletter',
});
